import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './css/Banner.css';

import BannerCamera from '../../../assets/img/banner/banner-cameras.jpg';
import ProductsCamera from '../../../assets/img/banner/prosucts-cameras.png';
import BannerLighting from '../../../assets/img/banner/banner-lighting.jpg';
import ProductsLighting from '../../../assets/img/banner/prosucts-lighting.png';
import BannerSoftware from '../../../assets/img/banner/banner-software.jpg';
import ProductsSoftware from '../../../assets/img/banner/prosucts-software.png';
import BannerSolutions from '../../../assets/img/banner/banner-solutions.jpg';
import ProductsSolutions from '../../../assets/img/banner/prosucts-solutions.png';

const AUTOSLIDE_INTERVAL = 5000;

function Banner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const bannerData = [
    // 檢測系統暫時隱藏
    // {
    //   id: 'camera',
    //   title: t('banner.camera.title'),
    //   subtitle: t('banner.camera.subtitle'),
    //   description: t('banner.camera.description'),
    //   bannerImg: BannerRanger,
    //   productImg: ProductsRanger,
    //   link: '/products/inspection',
    //   buttonText: t('banner.camera.buttonText')
    // },
    {
      id: 'sensor',
      title: t('banner.sensor.title'),
      subtitle: t('banner.sensor.subtitle'),
      description: t('banner.sensor.description'),
      bannerImg: BannerCamera,
      productImg: ProductsCamera,
      link: '/products/camera',
      buttonText: t('banner.sensor.buttonText')
    },
    {
      id: 'lighting',
      title: t('banner.lighting.title'),
      subtitle: t('banner.lighting.subtitle'),
      description: t('banner.lighting.description'),
      bannerImg: BannerLighting,
      productImg: ProductsLighting,
      link: '/products/lighting',
      buttonText: t('banner.lighting.buttonText')
    },
    {
      id: 'software',
      title: t('banner.software.title'),
      subtitle: t('banner.software.subtitle'),
      description: t('banner.software.description'),
      bannerImg: BannerSoftware,
      productImg: ProductsSoftware,
      link: '/products/software',
      buttonText: t('banner.software.buttonText')
    },
    {
      id: 'labeler',
      title: t('banner.automation.title'),
      subtitle: t('banner.automation.subtitle'),
      description: t('banner.automation.description'),
      bannerImg: BannerSolutions,
      productImg: ProductsSolutions,
      link: '/products/solutions',
      buttonText: t('banner.automation.buttonText')
    }
    // inspection 保留為翻譯資料來源但不顯示
  ];

  const currentBanner = bannerData[currentIndex];

  const startAutoslide = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % bannerData.length);
    }, AUTOSLIDE_INTERVAL);
  };

  const stopAutoslide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startAutoslide();
    return () => stopAutoslide();
  }, []);

  const handleButtonClick = (data) => {
    const newIndex = bannerData.findIndex(item => item.id === data.id);
    setCurrentIndex(newIndex);
    stopAutoslide();
    startAutoslide();
    navigate(data.link);
  };

  return (
    <div className="banner-wrapper relative w-full overflow-hidden">
      <div className="banner-container relative w-full overflow-hidden">
        <img
          src={currentBanner.bannerImg}
          alt="Banner Background"
          className="banner-bg-img w-full h-auto object-cover transition-opacity duration-500 ease-in-out"
        />
        <img
          src={currentBanner.productImg}
          alt={currentBanner.buttonText}
          className="banner-product-img absolute w-2/6 h-auto top-1/4 right-8 object-contain transition-opacity duration-500 ease-in-out z-10 md:w-1/3 md:top-24 md:right-4 sm:w-1/2 sm:top-20 sm:right-2"
        />
        <div className="banner-content absolute top-1/3 left-8 text-white z-20 md:left-4 sm:left-2 sm:top-1/4">
          <h1 className="text-5xl font-bold mb-2 md:text-4xl sm:text-3xl whitespace-pre-line">
            {currentBanner.title}
          </h1>
          {currentBanner.subtitle && (
            <h2 className="text-4xl font-semibold mb-4 md:text-3xl sm:text-2xl">
              {currentBanner.subtitle}
            </h2>
          )}
          <p className="text-xl mb-6 md:text-lg sm:text-base text-white">
            {currentBanner.description}
          </p>
          <button
            type="button"
            onClick={() => navigate(currentBanner.link)}
            className="banner-main-button inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-300 md:py-2 md:px-4 sm:py-2 sm:px-3 sm:text-sm"
          >
            {t('banner.learnMore')}
          </button>
        </div>
      </div>

      <div
        className="banner-nav-buttons-wrapper relative w-full bg-gray-900 bg-opacity-75 z-30"
        onMouseEnter={stopAutoslide}
        onMouseLeave={startAutoslide}
      >
        <div className="banner-nav-buttons flex justify-around p-4 flex-wrap">
          {bannerData.map((data) => (
            <button
              key={data.id}
              type="button"
              onMouseEnter={() => setCurrentIndex(bannerData.findIndex(item => item.id === data.id))}
              onClick={() => handleButtonClick(data)}
              className={`banner-nav-button flex-1 text-white p-3 text-center cursor-pointer transition-colors duration-300 ${currentBanner.id === data.id ? 'bg-blue-700' : 'hover:bg-gray-700'} md:p-2 sm:p-1 sm:text-xs flex flex-col items-center justify-center`}
            >
              <div className="mb-1">
                <img src={data.productImg} alt={data.buttonText} className="h-8 w-8 object-contain sm:h-6 sm:w-6" />
              </div>
              {data.buttonText}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Banner;